import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { ControlPoint as ControlPointIcon, ControlPointDuplicate as ControlPointDuplicateIcon } from "@mui/icons-material"
import { useMutation, useQuery, useQueryClient } from "react-query";
import { getProductsBySubcategory, updateActive, updateOrder } from "./services/api";
import { SnackbarGlobal } from "components/Snackbar";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { StyledMenu } from "components/Styled";
import { useTranslation } from "react-i18next";
import { ReactBeautifulDNDUpdateOrder, getActive } from "../routeHelpers";
import { ActionsDialogPage, ActionsMenuPage } from "./ActionsPage";
import { HeaderSectionMultiButton } from "components/Builder/HeaderSection";
import { /* DraggableRowActivateAccordionIcon,  */DraggableRowButtonMenu, DraggableRowDragIndicatorIcon, DraggableRowImage, DraggableRowText } from "components/Builder/DraggableRow";
import { ActiveSwitch } from "../ActionsPage";

export function Products({ menu, subcategory }) {
  const { t } = useTranslation();
  const [notification, setNotification] = useState({ open: false, message: "", severity: "" })
  const [openAction, setOpenAction] = useState(0) // 0: close, 1: add, 2: edit, 3: delete
  const [instanceSelected, setInstanceSelected] = useState({})
  const [showVariants] = useState(null)
  const [loadingUpdateActive, setLoadingUpdateActive] = useState(false)
  const [itemIdToUpdateActive, setItemIdToUpdateActive] = useState(null)
  const queryClient = useQueryClient()
  const { data: productsBySubcategories } = useQuery(
    ['productsBySubcategories', subcategory._id, menu], () => getProductsBySubcategory(subcategory._id, menu),
    { refetchOnWindowFocus: false, enabled: subcategory !== null && subcategory !== undefined }
  )

  useEffect(() => {
    console.log('subcategory', subcategory)
  }, [subcategory])

  const handleResetActions = () => { setOpenAction(0) }
  const handleWatchAction = (success, message, severity) => {
    setNotification({ open: true, message: message, severity: severity })
    if (success) { handleResetActions(); queryClient.invalidateQueries('productsBySubcategories') }
  }

  const [anchorElMenuActions, setAnchorElMenuActions] = useState(null)
  const open = Boolean(anchorElMenuActions)
  const handleClickMenuActions = (event, item) => {
    setAnchorElMenuActions(event.currentTarget); setInstanceSelected(item);
  }
  const handleCloseMenuActions = () => setAnchorElMenuActions(null)
  const handleMenuItemClick = (option) => { setOpenAction(option); handleCloseMenuActions(); }

  const mutation = useMutation(updateOrder, {
    onSuccess: (data) => { if (data.status === "success") { handleWatchAction(true, 'Acción realizada correctamente', 'success') } }
  })
  const handlerOrder = (params) => mutation.mutate(params)
  const handleDrop = (droppedItem) => {
    const order = ReactBeautifulDNDUpdateOrder(productsBySubcategories.data, droppedItem)
    if (order === false) return
    handlerOrder({ value: order })
  }

  const mutationUpdateActive = useMutation(updateActive, {
    onSuccess: (data) => {
      setLoadingUpdateActive(false)
      setItemIdToUpdateActive(null)
      if (data.status === "error") { handleWatchAction(false, 'Error al guardar los datos', 'error') }
      else { handleWatchAction(true, 'Acción realizada correctamente', 'success') }
    }
  })
  const handleUpdateActive = (item) => {
    setLoadingUpdateActive(true)
    setItemIdToUpdateActive(item._id)
    mutationUpdateActive.mutate({ id: item._id, params: { active: !item.active } })
  }

  return (<>
    <HeaderSectionMultiButton
      headerTitle={t('builder_products_title')}
      disabled={false}
      buttons={[
        { title: t('button_text_add'), action: setOpenAction, refAction: 1, icon: <ControlPointIcon /> },
        { title: `${t('button_text_add')} Multi`, action: setOpenAction, refAction: 7, icon: <ControlPointDuplicateIcon /> },
        { title: `Subir CSV`, action: setOpenAction, refAction: 8, icon: <ControlPointDuplicateIcon /> },
      ]} />
    <Grid container spacing={0}>
      {productsBySubcategories !== undefined ?
        <Grid item xs={12}  sx={{ height: "60vh", overflow: "auto" }}>
          {productsBySubcategories.data.length > 0 ?
            <DragDropContext onDragEnd={handleDrop}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <Grid container spacing={0} className="droppable" {...provided.droppableProps} ref={provided.innerRef}>
                    {productsBySubcategories.data.map((product, index) => (
                      <Draggable key={`${index}-${product._id}`} draggableId={product._id} index={index} isDragDisabled={showVariants !== null}>
                        {(provided) => (
                          <Grid ref={provided.innerRef} {...provided.draggableProps} container spacing={0} sx={{ padding: "10px 0px", alignItems: "center", borderTop: "1px solid rgba(224, 224, 224, 1)" }}>
                            <Grid item xs={1} {...provided.dragHandleProps}> <DraggableRowDragIndicatorIcon disabled={showVariants !== null} /> </Grid>
                            <Grid item xs={2}> <DraggableRowImage image={product.image} /> </Grid>
                            <Grid item xs={6}> <DraggableRowText text={product.name} /> </Grid>
                            <Grid item xs={3} sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                              <DraggableRowButtonMenu
                                open={open}
                                disabled={showVariants !== null}
                                action={(event) => handleClickMenuActions(event, product)} />
                              <ActiveSwitch
                                id={product._id}
                                loadingUpdateActive={loadingUpdateActive}
                                itemIdToUpdateActive={itemIdToUpdateActive}
                                getActive={getActive}
                                data={productsBySubcategories.data}
                                disabled={showVariants !== null}
                                onClick={() => handleUpdateActive(product)} />
                            </Grid>
                            {/* <Grid item xs={1}>
                              <DraggableRowActivateAccordionIcon
                                active={showVariants === product._id}
                                action={() => setShowVariants(showVariants === null || showVariants !== product._id ? product._id : null)} />
                            </Grid>
                            <Grid item xs={12}>
                              {showVariants === product._id ?
                                <div style={{ paddingLeft: 40 }}>
                                  {product.name}
                                </div> : null}
                            </Grid> */}
                          </Grid>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Grid>
                )}
              </Droppable>
            </DragDropContext>
            : <p>NO hay registros</p>}
        </Grid>
        : null}
    </Grid>
    <StyledMenu
      id={`demo-customized-product`}
      MenuListProps={{ 'aria-labelledby': `demo-customized-button-product` }}
      anchorEl={anchorElMenuActions}
      open={open}
      onClose={handleCloseMenuActions} >
      <ActionsMenuPage t={t} action={handleMenuItemClick} />
    </StyledMenu>
    <ActionsDialogPage
      open={openAction}
      close={() => handleResetActions()}
      menu={menu}
      subcategory={subcategory._id}
      columns={subcategory.columns !== undefined ? subcategory.columns : []}
      instance={instanceSelected}
      reportAction={handleWatchAction} />
    <SnackbarGlobal
      open={notification.open}
      close={() => setNotification({ open: false, message: "", severity: "" })}
      message={notification.message}
      severity={notification.severity} />
  </>)
}